function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o);
}
function _classCallCheck(a, n) { if (!(a instanceof n))
    throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
} }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t)
    return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i))
        return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
} return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e))
    return e; if (void 0 !== e)
    throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () { }));
}
catch (t) { } return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e)
    throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import { Box, Typography } from '@mui/material';
import React from 'react';
import Rocket from '../../public/FallenRocket.svg';
import { AuthorizationAPI } from '../apis';
import { constants } from '../constants';
import Cookies from 'js-cookie';
var ErrorBoundary = /*#__PURE__*/ function (_React$Component) {
    function ErrorBoundary(props) {
        var _this;
        _classCallCheck(this, ErrorBoundary);
        _this = _callSuper(this, ErrorBoundary, [props]);
        // Define a state variable to track whether is an error or not
        _this.state = {
            hasError: false,
            errorMsg: ''
        };
        return _this;
    }
    _inherits(ErrorBoundary, _React$Component);
    return _createClass(ErrorBoundary, [{
            key: "componentDidCatch",
            value: function componentDidCatch(error) {
                // You can use your own error logging service here
                this.setState({
                    errorMsg: error.message
                });
                AuthorizationAPI.logError({
                    msg: "".concat(Cookies.get('ui_trace_id'), "-").concat(error.stack)
                }).then(function (response) {
                    console.log(response);
                });
            }
        }, {
            key: "render",
            value: function render() {
                // Check if the error is thrown
                if (this.state.hasError) {
                    // You can render any custom fallback UI
                    return /*#__PURE__*/ React.createElement(Box, {
                        sx: {
                            textAlign: 'center',
                            mt: 30
                        }
                    }, /*#__PURE__*/ React.createElement("img", {
                        src: Rocket,
                        alt: 'Crashed',
                        height: 350,
                        width: 350
                    }), /*#__PURE__*/ React.createElement(Typography, {
                        variant: "h5",
                        color: "#000000DE",
                        sx: {
                            mt: 4,
                            mb: 2
                        }
                    }, constants.page_crashed), /*#__PURE__*/ React.createElement(Typography, {
                        variant: "body1",
                        color: "#000000DE"
                    }, this.state.errorMsg));
                }
                // Return children components in case of no error
                return this.props.children;
            }
        }], [{
            key: "getDerivedStateFromError",
            value: function getDerivedStateFromError() {
                // Update state so the next render will show the fallback UI
                return {
                    hasError: true
                };
            }
        }]);
}(React.Component);
export default ErrorBoundary;
